// extracted by mini-css-extract-plugin
export default {"flex":"Flex_flex__Ex5w+","flex-item":"Flex_flex-item__K9LJD"};